export default __webpack_public_path__ + "static/3p9-cornerstone-3d-2.0-8228d2ea85db1381896a1c50ea7dcc83.png";